export default "__VITE_ASSET__8a85ce99__"